<template>
  <div class="px-2 lg:px-2.5 xl:px-3 py-3 lg:py-3.5 xl:py-4 rounded-[10px] bg-cw-green-alt font-bold min-w-[4em]">
    <p :class="['text-lg lg:text-xl xl:text-2xl text-center text-cw-green-muted font-bold leading-[1.4]', { 'text-cw-red-alt': shouldIntensify && isLowTime }]">
      {{ formattedTime.display }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useTimer } from '@/composables/useTimer'
import { useSound } from '@/composables/useSound'
import { watch, onUnmounted } from 'vue'

const { playCountdown, stopCountdown } = useSound()

const {
  timeRemaining,
  shouldIntensify = true,
  autoStart = true
} = defineProps<{
  timeRemaining: number
  shouldIntensify?: boolean
  autoStart?: boolean
}>()

const emit = defineEmits<{
  timeUp: []
  tick: [timeLeft: number]
}>()

const { formattedTime, isLowTime } = useTimer({
  timeRemaining,
  autoStart,
  onTimeUp: () => {
    stopCountdown()
    emit('timeUp')
  },
  onTick: timeLeft => emit('tick', timeLeft)
})

watch(
  () => isLowTime.value,
  isNewLowTime => {
    if (isNewLowTime) {
      playCountdown()
    } else {
      stopCountdown()
    }
  }
)

onUnmounted(() => {
  stopCountdown()
})
</script>
